module.exports = __webpack_public_path__ + "static/media/login.98d96d0e.png";